import { render, staticRenderFns } from "./icon_button.vue?vue&type=template&id=3e137ed6&"
import script from "./icon_button.vue?vue&type=script&lang=js&"
export * from "./icon_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e137ed6')) {
      api.createRecord('3e137ed6', component.options)
    } else {
      api.reload('3e137ed6', component.options)
    }
    module.hot.accept("./icon_button.vue?vue&type=template&id=3e137ed6&", function () {
      api.rerender('3e137ed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/icon_button.vue"
export default component.exports